import React, { Component } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/CloudDownload';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import MainStore from '../../../MainStore';
import AuthStore from '../../Auth/AuthStore';
import WorkStore from '../Kanban/WorkStore';
import WorkDialog from '../Kanban/WorkDialog';
import ProjectSelect from '../Projects/ProjectSelect';
import ProjectStatistic from '../Projects/ProjectStatistic'
import './task.css'

export default class PeopleSchedule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filterProjectId: (localStorage.getItem('filterTasksProjectId') !== 'null' && !!localStorage.getItem('filterTasksProjectId')) ? localStorage.getItem('filterTasksProjectId') : '',
            filterProjectName: (localStorage.getItem('filterTasksProjectName') !== 'null') ? localStorage.getItem('filterTasksProjectName') : '',
            pageCount: 0,
            page: 0,
            works: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.load = this.load.bind(this);
        this.handleQuickFilterProjectChange = this.handleQuickFilterProjectChange.bind(this);
        this.handleWorkEdit = this.handleWorkEdit.bind(this);
        this.handleWorkUpdate = this.handleWorkUpdate.bind(this);
        this.handleEmptyAssigneeChange = this.handleEmptyAssigneeChange.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Work/GetByProject?projectId=' + this.state.filterProjectId + "&page=" + this.state.page + "&emptyAssignee=" + !!this.state.emptyAssignee, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ works: result.works, pageCount: result.pageCount });
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleEmptyAssigneeChange(evt) {
        this.setState({ emptyAssignee: evt.target.checked }, () => { this.load(); });
    }

    handleWorkEdit = workId => () => {
        MainStore.setMaskVisible();
        fetch('api/Work/GetWork?id=' + workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    WorkStore.openWorkDialog(result);
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleQuickFilterProjectChange(project) {
        if (project) {
            localStorage.setItem('filterTasksProjectId', project.id);
            localStorage.setItem('filterTasksProjectName', project.name);
            this.setState({ filterProjectId: project.id, filterProjectName: project.name }, () => { this.load() });
        }
        else {
            localStorage.setItem('filterTasksProjectId', '');
            localStorage.setItem('filterTasksProjectName', '');
            this.setState({ filterProjectId: '', filterProjectName: '' }, () => { this.load() });
        }
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleWorkUpdate(work) {
        this.load();
        /*MainStore.setMaskVisible();
        var works = this.state.works.slice(0);
        if (work.projectId !== this.state.filterProjectId) {
            works.splice(works.indexOf(w => w.id === work.id), 1);
            this.setState({ works: works });
        }
        else {
            var scope = this;
            fetch('api/Work/GetWorkByProject?workId=' + work.id, {
                method: 'GET',
                body: null,
            }).then(function (res) {
                if (res.status === 401) {
                    AuthStore.openLogin();
                    MainStore.setMaskUnvisible();
                }
                else {
                    res.json().then((result) => {
                        works.splice(works.findIndex(w => w.id === work.id), 1, result.work);
                        scope.setState({ works: works });
                        MainStore.setMaskUnvisible();
                    }).catch((err) => console.log(err));

                }
            });
        }*/
    }

    render() {
        return (
            <div>
                <WorkDialog onWorkUpdate={this.handleWorkUpdate} />
                <div className="clearfix">
                    <div className="quick-filter-item">
                        <ProjectSelect name={this.state.filterProjectName} handleSelect={this.handleQuickFilterProjectChange} showClosed={true}/>
                    </div>
                </div>
                <div className="taskboard-left">
                    <ProjectStatistic projectId={this.state.filterProjectId} />
                </div>
                <div className="taskboard-right">
                    <div className="taskboard-search-block">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.emptyAssignee}
                                    onChange={this.handleEmptyAssigneeChange}
                                    value="emptyAssignee"
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}
                                />}
                            label="Без ответственного"
                        />
                        <a href={'api/Work/GetCsvReportByProject?projectId=' + this.state.filterProjectId} download={this.state.filterProjectName + ' ' + new Date().toLocaleDateString() + ".csv"}><DownloadIcon /></a>
                    </div>
                    {this.state.works.map(w => <div className="taskboard-work-wrapper">
                        <div className="taskboard-work-info">
                            <div>{w.number} {w.caption}</div>
                            <div>Ответственный: {w.assignee} {w.sp}sp</div>
                            {w.tester && <div>Тестировщик: {w.tester} {w.testingSp}sp</div>}
                            <IconButton onClick={this.handleWorkEdit(w.id)} size="large">
                                <EditIcon/>
                            </IconButton>
                        </div>
                        {w.users &&
                        <div className="taskboard-work-graph">
                            <div className="taskboard-graph-item">
                                <div className="taskboard-graph-caption">Потрачено</div>
                                <div className="taskboard-graph-column" style={{ "width": "60%" }}/>
                                <span>{w.users.reduce((a, b) => a + b.totalHours, 0).toFixed(2)}</span>   
                            </div>

                            {w.users.map(u => <div className="taskboard-graph-item">
                                <div className="taskboard-graph-caption">{u.name}</div>
                                <div className="taskboard-graph-column" style={{ "width": (60 * u.totalHours / w.users.reduce((a, b) => a + b.totalHours, 0)).toString() + '%' }} />
                                <span>{u.totalHours.toFixed(2)}</span>
                            </div>)}
                        </div>}
                    </div>)}
                </div>
            </div>
        );
    }
}